import VideoWrapper from "../../../../src/components/VideoWrapper";
import * as React from 'react';
export default {
  VideoWrapper,
  React
};